<template>
  <Dialog :open="isOpen" @update:open="(v) => !v && hideModal()">
    <DialogContent class="max-w-md text-center overflow-hidden">
      <!-- Animated trophy / celebration icon -->
      <div class="flex justify-center mb-2">
        <div class="relative">
          <div class="text-7xl select-none">🎉</div>
        </div>
      </div>

      <DialogHeader class="text-center items-center">
        <DialogTitle class="text-2xl font-normal text-gray-900">
          Congratulations!
        </DialogTitle>
        <DialogDescription class="text-sm text-gray-600 mt-2 leading-relaxed text-pretty text-center">
          You've reached the <span class="font-semibold text-green-700">Offer Negotiation</span> stage!
          <br />
          That's a huge achievement! 🚀
        </DialogDescription>
      </DialogHeader>

      <div class="bg-gradient-to-br from-purple-50 to-green-50 rounded-xl p-4 border border-purple-100">
        <p class="text-sm text-gray-700 mb-3">
          To help track this milestone, please add an <strong>Offer Entry</strong> so your guide can support you through negotiations.
        </p>
        <a
          :href="offerCreateUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center gap-2 bg-cosmicPurple hover:bg-cosmicPurple/85 text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-all hover:shadow-md hover:translate-y-[-1px] duration-200"
          @click="hideModal"
        >
          <FileText class="w-4 h-4" />
          Create Offer Entry
          <ExternalLink class="w-3.5 h-3.5 opacity-70" />
        </a>
      </div>


    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import confetti from 'canvas-confetti'
import { FileText, ExternalLink } from 'lucide-vue-next'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { useOfferNegotiationModal } from '@/composables/useOfferNegotiationModal'

const { isOpen, applicationId, hideModal } = useOfferNegotiationModal()

const offerCreateUrl = computed(() =>
  `http://offers.outtalent.com/create-offer?job_application_id=${applicationId.value ?? ''}`
)

function launchConfetti() {
  const end = Date.now() + 2500

  const colors = ['#7c3aed', '#a78bfa', '#34d399', '#fbbf24', '#f472b6']

  const frame = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors,
    })
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors,
    })

    if (Date.now() < end) {
      requestAnimationFrame(frame)
    }
  }

  frame()
}

watch(isOpen, (opened) => {
  if (opened) {
    // Small delay so the modal is visible before confetti fires
    setTimeout(launchConfetti, 150)
  }
})
</script>

<style scoped>
@keyframes bounce-slow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.animate-bounce-slow {
  animation: bounce-slow 1.4s ease-in-out infinite;
}
</style>
